import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import ContentRow from './ContentRow';
import ContentHeader from './ContentHeader';
import EnvironmentManager from 'Utils/environmentManager';
import { toggleHRBetSlip } from 'Store/actions/horseRacing';
import { isBetSlipEmpty } from 'Utils/horseRacingBetslipValidation';
import { resetHRBetSlip } from 'Store/actions/horseRacing/betSlipActions';
import { PROGRAM_TYPES } from 'Store/constants/horseRacing';

const HorseRacingBetSlipContent = ({ selectedBet, legsData, onClose, betTypeText, isFixedOdd }) => {
  const selectedHorseLegs = useSelector( state => state.horseRacing.betSlip?.legs );
  const { combinedHorses } = useSelector(state => state.horseRacing.betSlip);
  const programType = useSelector(state => state.horseRacing.allHippodromes.programType);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isFixedOdd && isBetSlipEmpty(selectedHorseLegs)) {
      dispatch(resetHRBetSlip());
    }
  }, [selectedHorseLegs, isFixedOdd, dispatch]);

  const isInline = selectedBet?.legSize !== legsData?.length;
  const renderEmptyState = () => {
    const text = EnvironmentManager.getMessageText({ key: 'description_tjk_betslip_empty_state' });
    const buttonText = EnvironmentManager.getMessageText({ key: 'button_tjk_go_programme' });

    return (
      <div className="horse-racing-betslip__empty">
        <div className="horse-racing-betslip__empty-state">
          <div className="horse-racing-betslip__empty-state__text">
            { text }
          </div>
          <div className="horse-racing-betslip__empty-state__button" onClick={ () => {
            /*History.push(TJK_URL_SUFFIX.program.fullPage);*/
            onClose();
            dispatch(toggleHRBetSlip(false));
          } }>
            { buttonText }
          </div>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      {  (programType === PROGRAM_TYPES.JOINT ?  !isBetSlipEmpty(selectedHorseLegs) : combinedHorses?.length > 0) ? <div className="horse-racing-betslip__content">
        <ContentHeader betTypeText={ betTypeText } selectedHorseLegs={ selectedHorseLegs } selectedBet={ selectedBet } firstRaceItem={   programType === PROGRAM_TYPES.JOINT ? legsData[0] : {} } />
        <ContentRow forCouponRow={ false } selectedHorseLegs={ selectedHorseLegs } legsData={ legsData } betSlipBoxTitle={ selectedBet?.betslipBoxTitle } isInline={ isInline } />
      </div >
        : renderEmptyState() }
    </React.Fragment>
  );
};

HorseRacingBetSlipContent.propTypes = {
  selectedBet: PropTypes.object,
  legsData: PropTypes.array,
  onClose: PropTypes.func,
  verify: PropTypes.object,
  isLocaleCheckValid: PropTypes.bool,
  betTypeText: PropTypes.string,
  isFixedOdd: PropTypes.bool,
};

export default HorseRacingBetSlipContent;
